import countries from 'i18n-iso-countries';
import NL from 'i18n-iso-countries/langs/nl.json';
import { default as i18n, default as i18next } from 'i18next';
import Backend from 'i18next-xhr-backend';
import { initReactI18next } from 'react-i18next';
i18n
  // load translation using xhr -> see /public/locales
  // learn more: https://github.com/i18next/i18next-xhr-backend
  .use(Backend)
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  // .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    fallbackLng: 'nl-NL',
    debug: false,
    lng: 'nl-NL',
    supportedLngs: ['nl-NL'],
  });

i18next.loadNamespaces(['translation', 'management', 'errors']);
countries.registerLocale(NL);
export { countries };
export default i18n;
